import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './auth/AuthProvider';
import { initializeTheme } from './lib/theme';
import { landingPathForHost } from './lib/hostRouting';
import './index.css';

initializeTheme();

/**
 * A custom domain that should open one particular tool.
 *
 * Firebase Hosting maps a domain to a SITE, not to a path, and its rewrites cannot branch on the
 * request's host — so conflicts.aalrr.com arrives at `/` exactly like the main app does, and the
 * browser is the only place that knows which door somebody came through.
 *
 * DONE HERE, BEFORE REACT MOUNTS, rather than as a route. A second route matching `/` would sit
 * alongside the Shell's index route and leave which one wins to React Router's ranking — a risky
 * ambiguity when the loser is the home page for everybody in the firm. Rewriting the URL first
 * means there is still exactly one route for `/`, and no flash of the matter navigation before
 * the redirect.
 *
 * `replaceState`, not `assign`: no extra history entry, so Back leaves the site rather than
 * bouncing between the door and the page behind it.
 */
const landing = landingPathForHost(window.location.hostname, window.location.pathname);
if (landing) {
  window.history.replaceState(null, '', `${landing}${window.location.search}${window.location.hash}`);
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
